import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { enumData } from '@/decorators';
import { namespace } from 'vuex-class';
var User = namespace('user');

var PrintBoxMark = function (_super) {
  __extends(PrintBoxMark, _super);

  function PrintBoxMark() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.labelCol = {
      span: 4
    };
    _this.wrapperCol = {
      span: 20
    };
    _this.formData = _this.initFormData();
    _this.formDataRule = {
      board_no_start: [{
        required: true,
        message: _this.t('请输入开始箱号')
      }, {
        type: 'integer',
        message: _this.t('请输入整数')
      }],
      board_no_end: [{
        required: true,
        message: _this.t('请输入结束箱号')
      }, {
        type: 'integer',
        message: _this.t('请输入整数')
      }],
      print_num: [{
        required: true,
        message: _this.t('请输入数量')
      }, {
        type: 'integer',
        message: _this.t('请输入整数')
      }],
      print_size: [{
        required: true,
        message: _this.t('请选择打印尺寸')
      }]
    };
    _this.packageNumTotal = 0;
    _this.boxTotal = 0;
    _this.maxPrintCount = 2000;
    _this.boxPrintSizeEnum = [];
    return _this;
  }

  PrintBoxMark.prototype.onVisibleChange = function () {
    if (!this.visible) {
      var formDataRef = this.$refs.formDataRef;
      this.formData = this.initFormData();
      formDataRef.resetFields();
    } else {
      this.setPackageinfo();
    }
  };

  PrintBoxMark.prototype.initFormData = function () {
    return {
      order_code: this.data.order_code,
      board_no_start: 1,
      board_no_end: undefined,
      print_num: 1,
      print_size: this.$enum.common.BoxPrintSizeEnum.SMALL
    };
  };

  PrintBoxMark.prototype.setPackageinfo = function () {
    if (!this.data.detail_list || this.data.detail_list.length === 0) {
      return;
    }

    var boardNo = this.data.detail_list[0].board_no;
    var firstBoxDetails = this.data.detail_list.filter(function (item) {
      return item.board_no === boardNo;
    });
    this.packageNumTotal = firstBoxDetails.reduce(function (total, item) {
      return item.consumable_num + total;
    }, 0);
    var boxList = this.data.detail_list.map(function (item) {
      return item.board_no;
    });
    var boardCount = this.$util.arrayUnique(boxList).length;
    this.$set(this.formData, 'board_no_end', boardCount || 1);
    this.boxTotal = boardCount;
  };

  PrintBoxMark.prototype.printBoxMark = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var postData;

      var _this = this;

      return __generator(this, function (_a) {
        postData = this.$util.deepCopy(params);
        this.visible = false;
        setTimeout(function () {
          _this.$util.openPrintingPage(function () {
            return __awaiter(_this, void 0, void 0, function () {
              var data, e_1;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4, this.$api.wrapper.consumableMaterialInOrderPrintBoxLabel(postData, {
                      showError: false,
                      loading: false
                    })];

                  case 1:
                    data = _a.sent().data;
                    return [2, this.$util.getUrlByBase64(data, 'application/pdf')];

                  case 2:
                    e_1 = _a.sent();
                    return [2, Promise.reject(e_1)];

                  case 3:
                    return [2];
                }
              });
            });
          });
        }, 100);
        return [2];
      });
    });
  };

  PrintBoxMark.prototype.handleSubmit = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, totalBoxs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate(function () {})];

          case 1:
            _a.sent();

            if (this.formData.board_no_start > this.formData.board_no_end) {
              this.$message.warning(this.t('开始板号不能大于结束箱数'));
              return [2];
            }

            if (this.formData.board_no_end > this.boxTotal) {
              this.$message.warning(this.t('结束箱数不能大于{0}', [this.boxTotal]));
              return [2];
            }

            totalBoxs = this.formData.print_num * (this.formData.board_no_end - this.formData.board_no_start + 1);

            if (totalBoxs > this.maxPrintCount) {
              this.$message.warning(this.t('最多支持打印{0}个箱唛，总箱唛数=板数*数量。', [this.maxPrintCount]));
              return [2];
            }

            this.printBoxMark(this.formData);
            return [2];
        }
      });
    });
  };

  __decorate([User.State('userInfo')], PrintBoxMark.prototype, "userInfo", void 0);

  __decorate([Prop({
    type: Object,
    required: true,
    "default": function _default() {}
  })], PrintBoxMark.prototype, "data", void 0);

  __decorate([enumData('Wrapper/BoxPrintSizeEnum')], PrintBoxMark.prototype, "boxPrintSizeEnum", void 0);

  __decorate([Watch('visible')], PrintBoxMark.prototype, "onVisibleChange", null);

  PrintBoxMark = __decorate([Component], PrintBoxMark);
  return PrintBoxMark;
}(Vue);

export default PrintBoxMark;